import { NgModule } from '@angular/core';
import { environment } from '@env/environment';
import { CorePreloadingStrategy } from '@app/core/service/core-preloader';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { CommonState } from '@app/core/store/common/common.state';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';

@NgModule({
  imports: [
    NgxsModule.forRoot([CommonState], {
      developmentMode: !environment.production,
    }),
    NgxsRouterPluginModule.forRoot(),
    // The logger prints every action plus a full before/after copy of the
    // store. With this app's state that is a large object graph on every
    // dispatch, which makes a dev build feel like it has frozen — especially
    // with devtools attached. Opt in with NGXS_LOGGER=true when you actually
    // want the trace, rather than paying for it on every page load.
    NgxsLoggerPluginModule.forRoot({
      disabled: environment.production || !environment.ngxsLogger,
    }),
  ],
  providers: [CorePreloadingStrategy],
})
export class CoreModule {}
